module.exports = __webpack_public_path__ + "img/d_file.69caa872.png";